// @material-ui
import { makeStyles } from '@material-ui/styles'

const chartTick = theme => ({
  ...theme.typography.caption,
  fill: theme.typography.caption.color,
  fontSize: theme.typography.overline.fontSize,
})

export const currencyChartStyle = theme => ({
  root: {
    flexGrow: 1,
    overflow: 'visible',
  },

  content: {},

  chart: {
    zIndex: 1,
    position: 'relative',
    height: theme.spacing(25),
    margin: theme.spacing(3, 0, 1),
  },

  chartWrap: {
    height: theme.spacing(25),

    '& .recharts-cartesian-axis-tick-value': chartTick(theme),
  },

  chartTick: chartTick(theme),

  filter: {},

  checkbox: {
    paddingTop: 0,
    paddingBottom: 0,
  },

  label: {
    color: theme.typography.caption.color,
    fontWeight: theme.typography.fontWeightBold,
  },

  tooltip: {
    padding: theme.spacing(1, 1.5),
    zIndex: 5,
  },

  tooltipList: {
    marginTop: theme.spacing(),
  },

  tooltipItem: {
    padding: 0,
    color: theme.palette.text.primary,
  },

  tooltipTitle: {},

  tooltipName: {
    width: theme.spacing(6),
    paddingRight: theme.spacing(),
    fontWeight: theme.typography.fontWeightBold,
    display: 'inline-block',
  },
})

export const useCurrencyChartStyle = makeStyles(currencyChartStyle)
